module.exports = require("live/services/editor");